import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import UserForm from '../component/form/userForm'

import { v4 as uuidv4 } from 'uuid'

const UserModal = (props) => {
  const close = () => {
    props.setOpen(false);
  }

  const submit = (params) => {
    if(!('id' in params)){
      params.id = uuidv4();
    }
    props.datafunc(params);
    close();
  };

  return (
    <>
      <Dialog open={props.open} onClose={close}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          <UserForm process={submit} cancel={close} tenant={props.tenantlist} data={props.data}/>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserModal;